import { getDictOne } from "@/utils/storage";

const industryDict = (() => {
    const CodeList = getDictOne('industry_code');
    let arr = []
    CodeList.map((a) => {
        let obj = {}
        obj.value = a.dictKey;
        obj.label = a.dictValue
        arr.push(obj);
    })
    return arr
})
export const auditMechanismIndustry = industryDict();
export const veteransOutlook = [
    {
        value: "1",
        label: "党员",
    },
    {
        value: "2",
        label: "团员",
    },
    {
        value: "3",
        label: "群众",
    },
]

export const isWillingTrain = [
    {
        value: 0,
        label: "愿意",
    },
    {
        value: 1,
        label: "不愿意",
    }
]

export const auditMechanismNature = [{
    value: '1',
    label: '国有企业'
}, {
    value: '2',
    label: '私营企业'
}, {
    value: '3',
    label: '外资企业'
}]
